//      https://maps.googleapis.com/maps/api/js?key=AIzaSyAU-kC8TAzxbtAYNw1mHJIDaUljDI_XO4o&callback=doreaGMapsCallback&libraries=&v=weekly: { external: true}

(function ($, Drupal, document, window) {

  function getScript(scriptSrc, attributes) {
    let script = document.createElement('script');
    script.setAttribute('src', scriptSrc);

    if (attributes) {
      Object.keys(attributes).forEach(function (prop) {
        script.setAttribute(prop, attributes[prop]);
      });
    }

    return script;
  }

  function includeScript (scriptSrc, id, attributes, callback) {
    attributes = attributes || {};
    attributes.id = id;

    const script = getScript(scriptSrc, attributes);
    document.head.appendChild(script);

    // now wait for it to load...
    if (callback) {
      script.onload = callback
    }
  }

  function initMap(el) {
    const latLngBounds = new google.maps.LatLngBounds();

    const map = new google.maps.Map(el[0], {
      center: {lat: 51.4640975, lng: 10.5999716}, // germany
      zoom: 6,
      disableDefaultUI: true,
      streetViewControl: false,
      zoomControl: true
    });

    const infowindow = new google.maps.InfoWindow({
      maxWidth: 200,
    });

    /**
     *
     * @param {{name: string, geo: {lat: float, lng: float}, route: string, additional:boolean}} markerConf
     */
    const setMarker = function (markerConf) {
      const marker = new google.maps.Marker({
        position: markerConf.geo,
        map: map,

        icon: {
          url: 'https://maps.gstatic.com/mapfiles/transparent.png',
          size: new google.maps.Size(32, 44),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(16, 44),
        },
        label: {
          className: 'map-marker',
          text: "\ue914",
          fontFamily: "icomoon",
          color: '#a74d83',
          fontSize: "44px",
        },
        title: markerConf.name,
      });

      marker.addListener("click", function () {
        infowindow.setContent('<div class="map-content">' +
            '<div class="map-content__headline strong mb-1">' + markerConf.name + '</div>' +
            '<div class="mb-1">' + markerConf.address + '</div>' +
            '<a class="link link--arrow-right strong" href="' + markerConf.route + '">Mehr Informationen</a>' +
          '</div>'
        );
        infowindow.open({
          anchor: marker,
          map: map,
          shouldFocus: false,
        });
      });

      latLngBounds.extend(marker.position);
    };

    map.addListener("click", function () {
      // Close the current InfoWindow.
      infowindow.close();
    });


    el.data('map', map);
    el.data('locations').forEach(setMarker);
    el.data('latLngBounds', latLngBounds);

    if (el.data('center')) {
      map.setCenter(el.data('center'));
      map.setZoom(13);
    } else if (el.data('focus').length) {
      const focusBounds = new google.maps.LatLngBounds();
      el.data('focus').forEach(function (pos) {
        focusBounds.extend(pos);
      })
      map.setCenter(focusBounds.getCenter());
      map.fitBounds(focusBounds);
    } else {
      // Center map and adjust Zoom based on the position of all markers.
      map.setCenter(latLngBounds.getCenter());
      map.fitBounds(latLngBounds);
    }

  }

  var mapScriptLoaded = false;

  Drupal.behaviors.location_search = {
    attach: function (context, settings) {

      once('location_search', '.js-target-map', context).forEach((e) => {
        var el = $(e);
        var consent = null;

        function consentGiven () {
          el.parent().find('.embed-responsive-item').remove();
          if (mapScriptLoaded) {
            initMap(el);
          } else {
            includeScript('//maps.googleapis.com/maps/api/js?key=' + settings.googleMapsApiKey + '&callback=mapsCallback&libraries=&v=weekly')
          }
        }

        function consentDenied () {
          const overlay = $('<div class="embed-responsive-item embed-responsive-item--gdpr">' +
            '<div class="embed-responsive-item__info mb-3">' +
            '<h3 class="pink">' +  Drupal.t('Google Maps anzeigen?') + '</h3>' +
            '<p>' + Drupal.t('Möchten Sie die interaktive Karte von Google Maps anzeigen und damit die <a href="' + settings.cookiesjsr.services.maps.services[0].uri + '" class="link--text" target="_blank">Datenschutz Bestimmungen von Google</a> akzeptieren?') + '</p>' +
            '</div>' +
            '<div class="mb-3"><button class="js-always btn btn-primary">' + Drupal.t('Immer anzeigen') + '</button></div>' +
            '<div><button class="js-once btn btn-secondary">' + Drupal.t('Einmal anzeigen') + '</button></div>' +
            '</div>');

          el.parent().append(overlay);

          overlay.find('.js-always').click(function () {
            document.dispatchEvent(new CustomEvent('cookiesjsrSetService', { detail: { services: {google_maps: true} } }));
          });

          overlay.find('.js-once').click(function () {
            consentGiven();
          });
        }



        document.addEventListener('cookiesjsrUserConsent', function (event) {
          if (consent !== event.detail.services.google_maps) {
            consent = event.detail.services.google_maps;

            if (consent) {
              consentGiven();
            } else {
              consentDenied();
            }
          }
        });
      });

    }
  }

  window.mapsCallback = function () {
    mapScriptLoaded = true;
    $('.js-target-map').each(function () {
      initMap($(this));
    })
  }

})(jQuery, Drupal, document, window);
